/* ============================================================
   Iconos SVG (stroke). Reemplazan el <symbol> sprite del HTML.
   Uso: <IcoBell /> · tamaño y color se heredan (width/height/color).
   Todos comparten los mismos atributos de trazo.
   ============================================================ */
import React from 'react';

const S = ({ size = 18, children, ...rest }) => (
    <svg
        className="ic"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
        aria-hidden="true"
        {...rest}
    >
        {children}
    </svg>
);

/* navegación / estructura */
export const IcoGrid = (p) => <S {...p}><rect x="3" y="3" width="7" height="7" rx="1.8" /><rect x="14" y="3" width="7" height="7" rx="1.8" /><rect x="3" y="14" width="7" height="7" rx="1.8" /><rect x="14" y="14" width="7" height="7" rx="1.8" /></S>;
export const IcoLayout = (p) => <S {...p}><rect x="3" y="4" width="18" height="16" rx="2.5" /><path d="M3 10h18M9 10v10" /></S>;
export const IcoReceipt = (p) => <S {...p}><path d="M6 3h12v18l-3-2-3 2-3-2-3 2z" /><path d="M9 8h6M9 12h6" /></S>;
export const IcoBox = (p) => <S {...p}><path d="M12 3l8 4.5v9L12 21l-8-4.5v-9z" /><path d="M4 7.5l8 4.5 8-4.5M12 12v9" /></S>;
export const IcoCash = (p) => <S {...p}><rect x="3" y="6" width="18" height="12" rx="2.5" /><circle cx="12" cy="12" r="2.5" /><path d="M7 12h.01M17 12h.01" /></S>;
export const IcoChart = (p) => <S {...p}><path d="M5 20v-8M11 20V5M17 20v-5M3 20h18" /></S>;
export const IcoSliders = (p) => <S {...p}><path d="M4 6h8M18 6h2M4 12h2M12 12h8M4 18h8M18 18h2" /><circle cx="15" cy="6" r="2" /><circle cx="9" cy="12" r="2" /><circle cx="15" cy="18" r="2" /></S>;
export const IcoHelp = (p) => <S {...p}><circle cx="12" cy="12" r="9" /><path d="M9.6 9.5a2.5 2.5 0 1 1 3.5 2.3c-.7.3-1.1.9-1.1 1.7M12 17h.01" /></S>;

/* acciones */
export const IcoBell = (p) => <S {...p}><path d="M6 9a6 6 0 0 1 12 0c0 6 2.5 8 2.5 8h-17S6 15 6 9" /><path d="M10 21a2 2 0 0 0 4 0" /></S>;
export const IcoCalendar = (p) => <S {...p}><rect x="3" y="5" width="18" height="16" rx="2.5" /><path d="M3 10h18M8 3v4M16 3v4" /></S>;
export const IcoPencil = (p) => <S {...p}><path d="M12 20h9" /><path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z" /></S>;
export const IcoTrash = (p) => <S {...p}><path d="M4 7h16M9 7V4h6v3M6 7l1 13h10l1-13" /></S>;
export const IcoSearch = (p) => <S {...p}><circle cx="11" cy="11" r="7" /><path d="M21 21l-4.3-4.3" /></S>;
export const IcoLink = (p) => <S {...p}><path d="M10 13a5 5 0 0 0 7 0l3-3a5 5 0 0 0-7-7l-1 1" /><path d="M14 11a5 5 0 0 0-7 0l-3 3a5 5 0 0 0 7 7l1-1" /></S>;
export const IcoMove = (p) => <S {...p}><path d="M5 9l-3 3 3 3M9 5l3-3 3 3M15 19l-3 3-3-3M19 9l3 3-3 3M2 12h20M12 2v20" /></S>;
export const IcoMaximize = (p) => <S {...p}><path d="M8 3H3v5M16 3h5v5M8 21H3v-5M16 21h5v-5" /></S>;
export const IcoMenu = (p) => <S {...p}><path d="M4 7h16M4 12h16M4 17h16" /></S>;
export const IcoX = (p) => <S {...p}><path d="M6 6l12 12M18 6L6 18" /></S>;
export const IcoLogout = (p) => <S {...p}><path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" /><path d="M16 17l5-5-5-5" /><path d="M21 12H9" /></S>;

/* chevrons / +/- / checks */
export const IcoChevD = (p) => <S {...p}><path d="M6 9l6 6 6-6" /></S>;
export const IcoChevU = (p) => <S {...p}><path d="M6 15l6-6 6 6" /></S>;
export const IcoChevL = (p) => <S {...p} strokeWidth="2"><path d="M15 6l-6 6 6 6" /></S>;
export const IcoChevR = (p) => <S {...p} strokeWidth="2"><path d="M9 6l6 6-6 6" /></S>;
export const IcoPlus = (p) => <S {...p} strokeWidth="2"><path d="M12 5v14M5 12h14" /></S>;
export const IcoMinus = (p) => <S {...p} strokeWidth="2"><path d="M5 12h14" /></S>;
export const IcoCheck = (p) => <S {...p} strokeWidth="2"><path d="M5 12l5 5L20 7" /></S>;
export const IcoCheckCircle = (p) => <S {...p}><circle cx="12" cy="12" r="9" /><path d="M8.5 12.5l2.5 2.5 5-5" /></S>;

/* detalle / paneles */
export const IcoUser = (p) => <S {...p}><circle cx="12" cy="8" r="4" /><path d="M4 21a8 8 0 0 1 16 0" /></S>;
export const IcoUserPlus = (p) => <S {...p}><circle cx="10" cy="8" r="4" /><path d="M2 21a8 8 0 0 1 16 0M19 8v6M16 11h6" /></S>;
export const IcoClock = (p) => <S {...p}><circle cx="12" cy="12" r="9" /><path d="M12 7v5l3 2" /></S>;
export const IcoQr = (p) => <S {...p}><rect x="3" y="3" width="7" height="7" rx="1.5" /><rect x="14" y="3" width="7" height="7" rx="1.5" /><rect x="3" y="14" width="7" height="7" rx="1.5" /><path d="M14 14h3v3h-3zM20 14h1M14 20v1M20 20h1v1" /></S>;

/* vistas */
export const IcoTable = (p) => <S {...p}><rect x="3" y="4" width="18" height="16" rx="2.5" /><path d="M3 10h18M3 15h18M9 10v10" /></S>;
export const IcoWindow = (p) => <S {...p}><rect x="3" y="4" width="18" height="16" rx="2.5" /><path d="M3 9h18" /></S>;
export const IcoDock = (p) => <S {...p}><rect x="3" y="4" width="18" height="16" rx="2.5" /><path d="M15 4v16" /></S>;

/* objetos del tablero */
export const IcoShapes = (p) => <S {...p}><rect x="3" y="3" width="8" height="8" rx="1.5" /><circle cx="17" cy="7" r="4" /><path d="M3 21l4-7 4 7z" /><rect x="14" y="14" width="7" height="7" rx="1.5" /></S>;
export const IcoWall = (p) => <S {...p}><path d="M3 6h18M3 12h18M3 18h18M8 6v6M16 12v6M12 6v0" /></S>;
export const IcoDoor = (p) => <S {...p}><path d="M5 21V4a1 1 0 0 1 1-1h12a1 1 0 0 1 1 1v17M3 21h18M15 12h.01" /></S>;
export const IcoLeaf = (p) => <S {...p}><path d="M4 20c0-9 6-15 16-16-1 10-7 16-16 16z" /><path d="M4 20l8-8" /></S>;
export const IcoBar = (p) => <S {...p}><path d="M3 8h18M5 8l2 12h10l2-12M9 4h6" /></S>;